import { Helmet } from 'react-helmet-async';
import HeroSection from '../components/HeroSection';
import StoreList from '../components/stores/StoreList';
import storesHero from '../assets/images/hero/stores.png';

const Stores = () => {
  return (
    <div>
      <Helmet>
        <title>Store Locations | Grace Super Market Chennai</title>
        <meta name="description" content="Find Grace Super Market stores near you in Chennai. Visit our 39 convenient locations for fresh groceries, quality products, and excellent service." />
        <meta name="keywords" content="Grace Super Market locations, Chennai supermarket stores, grocery store locations, retail stores Chennai" />
        <meta property="og:title" content="Store Locations | Grace Super Market Chennai" />
        <meta property="og:description" content="Find Grace Super Market stores near you in Chennai. Visit our 39 convenient locations for fresh groceries, quality products, and excellent service." />
        <meta property="og:image" content={storesHero} />
        <meta property="og:type" content="website" />
        <link rel="canonical" href={`${process.env.REACT_APP_CURRENT_URL}/stores`} />
      </Helmet>

      <HeroSection
        title="Our Stores"
        description="Find a Grace Super Market Near You"
        image={storesHero}
      />
      <section className="py-12">
        <div className="container mx-auto  px-6 md:px-20">
          <h2 className="text-3xl font-bold text-gray-800 mb-6">Stores</h2>
          <StoreList />
        </div>
      </section>
    </div>
  );
};

export default Stores;